<script setup lang="ts">
import Button from "@/shared/components/Button/Button.vue";
import Infobox from "@/shared/components/Infobox/Infobox.vue";

const redirectToLogin = () => {
  const url = new URL(__LOGIN_URL__);
  window.location.href = url.toString();
};
</script>

<template>
  <Infobox status="info">
    <div class="user-already-exists-info">
      <p>
        {{ $t("registration.user.new.info.userAlreadyExists.text1") }}
      </p>
      <i18n-t
        keypath="registration.user.new.info.userAlreadyExists.text2.base"
        tag="p"
      >
        <template #support>
          <a
            :href="$t('shared.corporate.service.link.contact.path')"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{
              $t("registration.user.new.info.userAlreadyExists.text2.support")
            }}
          </a>
        </template>
      </i18n-t>
      <Button
        :caption="$t('registration.user.new.info.userAlreadyExists.action')"
        @click="redirectToLogin"
      />
    </div>
  </Infobox>
</template>

<style scoped>
@import "UserAlreadyExistsInfo.css";
</style>
